import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current path
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar scrolled">
      <div className="logo">
        <Link to="/" style={{ textDecoration: "none" }}>
          E-TECHNO
        </Link>
      </div>
      <button className={`menu-toggle ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span className="hamburger"></span>
      </button>
      <div className={`nav-container ${isMenuOpen ? "active" : ""}`}>
        <ul className="nav-links">
          <li>
            <Link
              to="/about"
              className={location.pathname === "/about" ? "active" : ""}
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to="/mission"
              className={location.pathname === "/mission" ? "active" : ""}
              onClick={() => setIsMenuOpen(false)}
            >
              Our Mission
            </Link>
          </li>
          <li>
            <Link
              to="/gallery"
              className={location.pathname === "/gallery" ? "active" : ""}
              onClick={() => setIsMenuOpen(false)}
            >
              Gallery
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              className={location.pathname === "/contact" ? "active" : ""}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </Link>
          </li>
        </ul>
        <button
          className="donate-button"
          onClick={() => {
            navigate("/donate-form");
            setIsMenuOpen(false);
          }}
        >
          Donate
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
